import React, { useEffect, useState } from 'react'
import PopUp from '../../ui/PopUp/PopUp'
import Field from '../../ui/Field/Field'
import { slugifyBlogTitle } from '../../api/blog/blogSlug'
import styles from './Blog.module.scss'

const blankDraft = () => ({
  id: null,
  name: '',
  slug: '',
  kind: 'tag',
  order: 0,
  publishedCount: 0,
  slugTouched: false,
})

function BlogTagPopUp({ open, initialTag, isSaving, onClose, onSave }) {
  const [draft, setDraft] = useState(blankDraft)

  useEffect(() => {
    if (!open) return
    if (initialTag?.id) {
      setDraft({
        id: initialTag.id,
        name: initialTag.name || '',
        slug: initialTag.slug || '',
        kind: initialTag.kind === 'category' ? 'category' : 'tag',
        order: initialTag.order || 0,
        publishedCount: Number.isInteger(initialTag.publishedCount) ? initialTag.publishedCount : 0,
        slugTouched: true,
      })
      return
    }
    setDraft(blankDraft())
  }, [open, initialTag])

  const handleSave = () => {
    const name = draft.name.trim()
    if (!name) return
    const slug = (draft.slug || '').trim() || slugifyBlogTitle(name)
    onSave({
      id: draft.id,
      name,
      slug,
      kind: draft.kind,
      order: draft.order,
      publishedCount: draft.publishedCount,
    })
  }

  return (
    <PopUp
      show={open}
      title={draft.id ? 'Редагувати категорію або тег' : 'Нова категорія або тег'}
      close={onClose}
      submitButtons
      isLoading={isSaving}
      onSubmit={handleSave}
      className={styles.tagPopUp}
    >
      <div className={styles.tagPopUpBody}>
        <Field
          fieldType="select"
          config={{ label: 'Тип', getOptions: [{ value: 'category', label: 'Категорія' }, { value: 'tag', label: 'Тег' }] }}
          value={draft.kind}
          changed={(event) => setDraft((prev) => ({ ...prev, kind: event.target.value }))}
        />
        {draft.kind === 'category' ? (
          <Field
            fieldType="input"
            config={{ label: 'Порядок у навігації', type: 'number', min: 0, max: 10000, step: 1 }}
            value={draft.order}
            changed={(event) => setDraft((prev) => ({ ...prev, order: Number(event.target.value) }))}
          />
        ) : null}
        <Field
          fieldType="input"
          config={{ label: 'Назва', type: 'text' }}
          value={draft.name}
          changed={(event) => {
            const name = event.target.value
            setDraft((prev) => ({
              ...prev,
              name,
              slug: prev.slugTouched ? prev.slug : slugifyBlogTitle(name),
            }))
          }}
        />
        <Field
          fieldType="input"
          config={{ label: 'Slug', type: 'text' }}
          value={draft.slug}
          changed={(event) =>
            setDraft((prev) => ({
              ...prev,
              slug: event.target.value,
              slugTouched: true,
            }))
          }
        />
      </div>
    </PopUp>
  )
}

export default BlogTagPopUp
